import * as React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Provider from "components/context/Context";
import globalStyle from "styles/GlobalStyle";
import { ConfigProvider } from "antdv5";
import { Global } from "@emotion/react";
import MatchPage from "pages/MatchPage";
import Racelive from "pages/Racelive";
import Login from "pages/Login";
import ScanDetail from "pages/ScanDetail";
import DailyRecord from "pages/DailyRecord";
import DeviceConnect from "pages/DeviceConnect";
import DeviceList from "pages/DeviceList";
import TrainRecord from "pages/TrainRecord";
import DailyTotal from "pages/DailyTotal";
import DeviceOrder from "pages/DeviceOrder";
import NotFound from "pages/NotFound";
import { StyleProvider } from "@ant-design/cssinjs";
import Settings from "pages/Settings";
import PageRoute from "components/common/Route";

const { REACT_APP_BASE_URL } = process.env;

function App() {
  return (
    <StyleProvider hashPriority="high">
      <Global styles={globalStyle} />
      <ConfigProvider
        theme={{
          token: {
            fontSize: 16,
          },
        }}
      >
        <Provider>
          <BrowserRouter basename={REACT_APP_BASE_URL}>
            <Switch>
              <PageRoute exact path="/" showSetting={1}>
                <MatchPage />
              </PageRoute>
              <PageRoute exact path="/racelive/:matchid/" showSetting={1}>
                <Racelive showNewest />
              </PageRoute>
              <PageRoute
                exact
                path="/racelive/:matchid/:gameid/:gametype"
                showSetting={1}
              >
                <Racelive showNewest={false} />
              </PageRoute>
              <PageRoute exact path="/login" showSetting={1}>
                <Login />
              </PageRoute>
              <PageRoute
                exact
                path="/scan_detail/:clubID?"
                showSetting={2}
                requireGid
              >
                <ScanDetail />
              </PageRoute>
              <PageRoute exact path="/daily_record/:clubID" showSetting={2}>
                <DailyRecord />
              </PageRoute>
              <PageRoute exact path="/device_connection" showSetting={2}>
                <DeviceConnect />
              </PageRoute>
              <PageRoute exact path="/device_list" showSetting={2}>
                <DeviceList />
              </PageRoute>
              <PageRoute exact path="/train_record" showSetting={2}>
                <TrainRecord />
              </PageRoute>
              <PageRoute exact path="/daily_total" showSetting={2}>
                <DailyTotal />
              </PageRoute>
              <PageRoute exact path="/settings/:page" showSetting={2}>
                <Settings />
              </PageRoute>
              <PageRoute exact path="/device_order" showSetting={3}>
                <DeviceOrder />
              </PageRoute>
              <Route path="*" component={NotFound} />
            </Switch>
          </BrowserRouter>
        </Provider>
      </ConfigProvider>
    </StyleProvider>
  );
}

export default App;
